import { useState, useEffect } from 'react';
import { collection, onSnapshot, query, orderBy } from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';
import { firestore, auth } from '../services/firebase';
import { Artwork } from '../types/artwork';

const useFirestore = () => {
    const [artworks, setArtworks] = useState<Artwork[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
            if (user) {
                console.log('User authenticated, loading artworks');
                const q = query(collection(firestore, 'artworks'), orderBy('createdAt', 'desc'));
                const unsubscribeFirestore = onSnapshot(q,
                    (snapshot) => {
                        const fetchedArtworks: Artwork[] = [];
                        snapshot.forEach((doc) => {
                            fetchedArtworks.push({ id: doc.id, ...doc.data() } as Artwork);
                        });
                        console.log('Fetched artworks:', fetchedArtworks);
                        setArtworks(fetchedArtworks);
                        setLoading(false);
                        setError(null);
                    },
                    (err) => {
                        console.error('Firestore error:', err);
                        setError(err.message);
                        setLoading(false);
                    }
                );

                return () => unsubscribeFirestore();
            } else {
                console.log('User not authenticated');
                setArtworks([]);
                setLoading(false);
                setError(null);
            }
        });

        return () => unsubscribeAuth();
    }, []);

    return { artworks, loading, error };
};

export default useFirestore;